// React imports.
import React, { Component } from "react";
const FiscalYears = ({ fiscalYears, toggleFiscalYearSelected}) => (
  <div className="verticalList" >
    {fiscalYears
      .map(y => (
        <label key={y.fiscalYear}>
          <input type="checkbox" value={y.fiscalYear}
            onChange={e => toggleFiscalYearSelected(y.fiscalYear)}
            checked={y.fiscalYearSelected}/>
          <span >{y.fiscalYear + (y.final?'':'*')}</span>
        </label>
      ))}
  </div>
);

export default FiscalYears;
